import ClienteEnderecoService from "@/services/ClienteEnderecoService";

export const clienteEndereco = {
  namespaced: true,
  state: {
    clienteEndereco: {},
  },
  actions: {
    getClienteEndereco({ commit }, payload) {
      return ClienteEnderecoService.GetClienteEndereco(payload).then(
        (clienteEndereco) => {
          return Promise.resolve(clienteEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postClienteEndereco({ commit }, payload) {
      return ClienteEnderecoService.PostClienteEndereco(payload).then(
        (clienteEndereco) => {
          return Promise.resolve(clienteEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putClienteEndereco({ commit }, payload) {
      return ClienteEnderecoService.PutClienteEndereco(payload).then(
        (clienteEndereco) => {
          return Promise.resolve(clienteEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteClienteEndereco({ commit }, payload) {
      return ClienteEnderecoService.DeleteClienteEndereco(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getClienteEnderecoOData({ commit }, payload) {
      return ClienteEnderecoService.GetClienteEnderecoOData(payload).then(
        (clienteEndereco) => {
          return Promise.resolve(clienteEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default clienteEndereco;
